
export interface IEnv {
  isAndroid: boolean;
  isPc: boolean;
  isDev: boolean;
  isProd: boolean;
  gateway: string;
  isOnlineEnv: boolean;
  isAndroidApp: boolean;
  htmlOrigin: string;
  initialized: boolean;
}

export const env:IEnv = {
  isAndroid: false,
  isPc: false,
  isDev: false,
  isProd: false,
  gateway: '',
  isOnlineEnv: false,
  isAndroidApp: false,
  htmlOrigin: '',
  initialized: false,
}

const gatewayMap:Record<string, string> = {
  // '192.168.177.180': '//192.168.1.100:19010/v1/',
  '3000.shangwoa.xyz': '//19010.shangwoa.xyz/v1/',
  // '192.168.177.180': '//localhost:19010/v1/',//可以测试跨域
  'homepage.vm-ubuntu.droidlego.com': '//homepage_server.vm-ubuntu.droidlego.com/v1/',
}
const defGateway = '//droid_go_main.dev1.fanfanlo.com/v1/'
// const defGateway = '//html.droid.qiwoa.com/v1/'
function getGateway():string{
  if(typeof window === 'undefined')return defGateway
  const u = new URL(window.location.href)
  if(gatewayMap[u.hostname])return gatewayMap[u.hostname]
  const reg = /\d+\.\d+\.\d+\.\d+/
  const res = u.hostname.match(reg)
  if(res){
    return require('./gateway.local.conf').gateway
  }
  return defGateway
}

initEnv()
export function initEnv() {
  if(typeof navigator === 'undefined')return env;
  if(env.initialized) return env;
  if(typeof window === 'undefined' )return env;
  const isAndroid = typeof navigator !== 'undefined' ?
    navigator.userAgent.toLowerCase().indexOf('android') > -1 || navigator.userAgent.toLowerCase().indexOf('adr') > -1 : false
  const isPc = !isAndroid;
  const dev = 'development'; 
  const prod = 'production';
  let isOnlineEnv = false;
  let gateway = '';
  let htmlOrigin = window.location.origin + '/';
  // gateway = `//${window.location.hostname}${window.location.port ? ':19010' : ''}/v1/`;
  gateway = getGateway()
  let isDev = process.env.NODE_ENV === dev;
  let isProd = window.location.port.length > 0;
  let isAndroidApp = window.location.href.indexOf('android=true') > -1;
  env.isAndroid = isAndroid;
  env.isPc = isPc;
  env.isDev = isDev;
  env.isProd = isProd;
  env.gateway = gateway;
  env.isOnlineEnv = isOnlineEnv;
  env.isAndroidApp = isAndroidApp;
  env.htmlOrigin = htmlOrigin;
  env.initialized = true;
  return env;
}